module.exports = __webpack_public_path__ + "static/comic-odyssey-screencast-d0ff854618baa12f75e5b139462b9bad.webm";